// "View as Customer" (Jeremy, 2026-09-02): an internal user looks at the Hub the way a customer
// contact does. The chosen scope is echoed on every API call as a header the API turns into a real
// ExternalPrincipal (apps/api/src/auth/jwt.strategy.ts), so the preview is enforced server-side --
// the bpa field allow-list, the AllowExternal deny-by-default and the project scoping all apply,
// rather than the browser dressing an internal response up as a customer one.
//
// sessionStorage rather than localStorage: this is a look, not a setting, so it dies with the tab.
// AuthGate also clears it on the sign-in screen, which is what makes signing out revert to self
// however that sign-out happened (button, idle timeout, expired session).
const KEY = 'psops.viewAsCustomer';

// Mirrors CUSTOMER_PREVIEW_HEADER / CUSTOMER_PREVIEW_ALL in apps/api -- apps/web can't import from
// the API or packages/shared (ADR 0019).
export const PREVIEW_HEADER = 'X-View-As-Customer';
export const PREVIEW_ALL = 'all';

// '' when not previewing, otherwise PREVIEW_ALL or a project id.
export function getPreviewScope() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return ''; // private mode
  }
}

export function clearPreviewScope() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
}

// A full reload rather than React state: /auth/me answers differently now, and that answer picks
// the entire shell (AppShell.js). Reloading is both simpler and safer than teaching every mounted
// page to re-fetch itself as somebody else.
export function enterPreview(scope) {
  try {
    sessionStorage.setItem(KEY, scope);
  } catch {
    // Private mode: without storage the header can't be sent, so say so rather than reloading
    // into an unchanged view.
    // eslint-disable-next-line no-alert
    window.alert("This browser is blocking session storage, so the customer view can't be turned on.");
    return;
  }
  window.location.assign('/');
}

export function exitPreview() {
  clearPreviewScope();
  window.location.assign('/');
}

export function previewHeaders() {
  const scope = getPreviewScope();
  return scope ? { [PREVIEW_HEADER]: scope } : {};
}
